import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { DoseItem } from '../../components'
import CommentList from '../../components/comment-list'
import { IDose } from 'daily-dose-common'
import { firestore } from '../../firebase-init'
import { collectIdAndDocs } from '../../utilities'

// Max doses to query per page
const LIMIT = 2

const DoseDetailsPage = ({ match }: any) => {
  const [dose, setDose] = useState({} as IDose | undefined)
  const [loading, setLoading] = useState(true)

  const [comments, setComments] = useState([] as any[])
  const { circleId, doseId } = match.params
  const doseRef = firestore.doc(`circles/${circleId}/doses/${doseId}`)
  const commentsRef = doseRef.collection('comments')
  const commentsRefByDate = commentsRef.orderBy('createdAt', 'desc')

  useEffect(() => {
    const unsubscribeFromSelectedDose = doseRef.onSnapshot((snapshot) => {
      if (snapshot.exists) {
        setDose(collectIdAndDocs(snapshot) as IDose)
      }
    })

    const fetchComments = async () => {
      const commentsQuery = commentsRefByDate.limit(LIMIT)
      const comments = (await commentsQuery.get()).docs.map(collectIdAndDocs)
      setComments(comments)
      setLoading(false)
    }

    fetchComments()

    return () => {
      unsubscribeFromSelectedDose()
    }
    // eslint-disable-next-line
  }, [])

  if (!dose?.id) return null

  return (
    <div>
      {dose && (
        <section>
          {<DoseItem dose={dose} link />}
          {!loading && (
            <CommentList
              comments={comments}
              commentsRefByDate={commentsRefByDate}
              commentsRef={commentsRef}
              dose={dose}
            />
          )}
        </section>
      )}
    </div>
  )
}

export default withRouter(DoseDetailsPage)
